import { FlexGroupWrapper } from '@tecton/ComponentRedesign';
import { Card, FlexItem } from '@lithos';
import { FC } from 'react';
import { CustomGraph } from '../../../feature/feature-views/graph-types';
import { FEATURE_SERVER_GROUPS, FEATURE_SERVICE_GLOBAL_SLO } from '../../../feature/graph-configuration';
import { MonitoringDateRange } from '../../monitoring/DateRange-Dropdown-util';
import MonitoringGraphs from './MonitoringGraphs';
import styled from '@emotion/styled';
import { Button, FlexGroup, Icon, Popover } from '@lithos';
import { Link } from 'react-router-dom';
import { TECTON_DOCUMENTATION_LINKS } from '../application-links';
import SLOReliability30Days from './SLOReliability30Days';

const TriggerWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const ButtonLinkWrapper = styled.div`
  width: 100%;
`;

const FeatureServerGroup: FC<{
  monitoringDateRange: MonitoringDateRange;
  selectedWorkspace: string;
}> = ({ monitoringDateRange, selectedWorkspace }) => {
  const serverGroupName = 'default';

  const customGraphs: Record<string, React.ReactNode> = {
    [CustomGraph.FEATURE_SERVICE_GLOBAL_SLO_RELIABILITY]: (
      <>
        <Card
          title={
            <>
              <Popover
                body={
                  <>
                    This metric is calculated using a 30-day rolling window. Different time periods show snapshots of
                    these rolling averages at each point within that period.
                  </>
                }
                trigger={
                  <TriggerWrapper>
                    Reliability SLO
                    <Icon type="mono" size="s" icon="Information" />
                  </TriggerWrapper>
                }
                buttons={
                  <ButtonLinkWrapper>
                    <Link to={TECTON_DOCUMENTATION_LINKS.FEATURE_SERVER_PRODUCTION_SLO}>
                      <Button iconLeft="Book" iconRight="Popout" type="secondary" fullWidth label={'Learn more'} />
                    </Link>
                  </ButtonLinkWrapper>
                }
              />
            </>
          }
        >
          <FlexGroup padding="0" justifyContent="center" alignItems="center">
            <SLOReliability30Days monitoringDateRange={monitoringDateRange} />
          </FlexGroup>
        </Card>
      </>
    ),
  };
  return (
    <>
      <FlexGroupWrapper>
        <FlexItem>
          <MonitoringGraphs
            monitoringDateRange={monitoringDateRange}
            graphsData={FEATURE_SERVICE_GLOBAL_SLO}
            customGraphRecord={customGraphs}
            workspace={selectedWorkspace ?? ''}
          />
        </FlexItem>
        <FlexItem>
          <MonitoringGraphs
            monitoringDateRange={monitoringDateRange}
            graphsData={FEATURE_SERVER_GROUPS}
            customGraphRecord={{}}
            workspace={selectedWorkspace ?? ''}
            serverGroupName={`${serverGroupName}`}
          />
        </FlexItem>
      </FlexGroupWrapper>
    </>
  );
};

export default FeatureServerGroup;
